import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-campanha-pipeline-card-info-em-analise',
    templateUrl: './campanha-pipeline-card-info-em-analise.component.html',
    styleUrls: ['./campanha-pipeline-card-info-em-analise.component.less']
})
export class CampanhaPipelineCardInfoEmAnaliseComponent {
    @Input() dataSolicitacaoAnalise: Date;
    @Input() idUsuarioSolicitacaoAnalise: number;
    @Input() avatarURLUsuarioSolicitacaoAnalise: string;
    @Input() nomeUsuarioSolicitacaoAnalise: string;
}
